import { render, staticRenderFns } from "./VirtualClass.vue?vue&type=template&id=15f81884&"
import script from "./VirtualClass.vue?vue&type=script&lang=js&"
export * from "./VirtualClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports